import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { AuthStatusIcon } from '../components/auth/AuthStatusIcon';

/**
 * Goodbye screen shown after an organization account is permanently deleted.
 * The delete flow hard-navigates here (the session is already gone server-side),
 * so instead of silently dead-ending on the login page the user gets a clear
 * confirmation that everything was removed.
 */
export function AccountDeletedPage() {
  return (
    <Card className="flex flex-col items-center gap-4 p-8 text-center">
      <AuthStatusIcon variant="success" />
      <div>
        <h1 className="font-display text-xl font-bold text-bone">Your account has been deleted</h1>
        <p className="mt-1 text-sm text-muted">
          Your organization and all of its data have been permanently removed. Thanks for giving
          Lizrd a try — you're always welcome back.
        </p>
      </div>
      <Link
        to="/login"
        className="mt-1 w-full rounded-sm border border-border px-4 py-2 text-center text-sm font-semibold text-bone transition-colors hover:bg-surface-2"
      >
        Back to sign in
      </Link>
    </Card>
  );
}
